import { render, staticRenderFns } from "./TambahUser.vue?vue&type=template&id=ca0fdff0&"
import script from "./TambahUser.vue?vue&type=script&lang=js&"
export * from "./TambahUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports